import React from "react"
import { withRouter } from "react-router"
import styled from "styled-components"
import Login from "../../containers/Login"
import Signup from "../../containers/Signup"
import { isLogin, endEvent } from "../../utils"
import * as R from "ramda"

const StyledButton = styled.button.attrs({
  className: "ui button teal"
})`
&& {
  width: 100%
  margin-bottom: 1em
}
`

class OrderEvent extends React.Component {
  state = {
    showLogin: false,
    showSignup: false
  }

  render() {
    const { event } = this.props
    return (
      <React.Fragment>
        <div className="ui segment">
          <h1 style={{ textAlign: "center" }}>
            <span>{`${R.path(["price"], event.addons[0])} ฿`}</span>
          </h1>
          {endEvent(event) ? (
            <button
              className="ui button red mobile-not-show"
              style={{ width: "100%", marginBottom: "1em" }}
            >
              ปิดการสั่งซื้อ
            </button>
          ) : (
            <StyledButton
              className="mobile-not-show"
              onClick={() => {
                isLogin()
                  ? this.props.history.push(`/events/${event.slug}/order`)
                  : this.setState({ showLogin: true })
              }}
            >
              สั่งซื้อ
            </StyledButton>
          )}
        </div>
        <Login
          open={this.state.showLogin}
          onClose={() => this.setState({ showLogin: false })}
          toggleSignup={() => {
            this.setState({ showLogin: false })
            this.setState({ showSignup: true })
          }}
        />
        <Signup
          open={this.state.showSignup}
          onClose={() => this.setState({ showSignup: false })}
        />
      </React.Fragment>
    )
  }
}

export default withRouter(OrderEvent)



// WEBPACK FOOTER //
// /opt/build/repo/src/components/OrderEvent/index.js